"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareClaimTemplatesInitialValues = exports.claimTemplateFilter = exports.claimTemplateSearchValuesCreator = exports.claimTemplateEmptyValuesCreator = void 0;
const types_1 = require("@framework/types");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const exchange_1 = require("@framework/exchange");
const types_2 = require("../../../../../types");
const baseEmptyValues = {
    account: "",
    item: mui_inputs_asset_1.emptyItem,
    claimType: types_1.ClaimType.TEMPLATE,
    endTimestamp: new Date(0).toISOString(),
};
const claimTemplateEmptyValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        ...baseEmptyValues,
    },
    [types_2.ServiceType.OFFICE]: {
        ...baseEmptyValues,
        merchantId: profile.merchantId,
    },
});
exports.claimTemplateEmptyValuesCreator = claimTemplateEmptyValuesCreator;
const claimTemplateSearchValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        claimStatus: [],
    },
    [types_2.ServiceType.OFFICE]: {
        claimStatus: [],
        merchantId: profile.merchantId,
    },
});
exports.claimTemplateSearchValuesCreator = claimTemplateSearchValuesCreator;
const claimTemplateFilter = (service) => ({ item, claimType, account, endTimestamp, merchantId }) => ({
    item: (0, exchange_1.cleanUpAsset)(item),
    claimType,
    account,
    endTimestamp,
    merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
});
exports.claimTemplateFilter = claimTemplateFilter;
const prepareClaimTemplatesInitialValues = (service) => ({ id, item, account, endTimestamp, merchantId }) => {
    return {
        id,
        item,
        account,
        endTimestamp,
        merchantId: (service === types_2.ServiceType.OFFICE && merchantId) || undefined,
    };
};
exports.prepareClaimTemplatesInitialValues = prepareClaimTemplatesInitialValues;
//# sourceMappingURL=schemas.js.map